<template>
  <!-- <Header></Header> -->
  <div class="main-height">
    <section id="main">
      <div class="container-fluid">
        <div class="row vh-100">
          <div class="col-xxl-4 col-lg-5 col-md-6 p-4 ms-auto bg-white d-flex flex-column justify-content-md-center justify-content-center"
              id="signInForm" :class="{ 'qr-mode': showQR }" >
            <div v-if="showQR" class="qr-login-wrapper">
              <img src="../assets/images/logo-icon.svg" class="small-logo d-block mx-auto mb-4" alt="Logo" />
              <h5 class="qr-title text-center fw-bold">Link your device to ProcPlayer.tv</h5>
              <p class="text-center">Scan the QR code with your phone</p>
              <div v-if="qrLoading" class="text-center my-3">
                <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
              </div>
              <div id="qrBox" class="qr-img"></div>
              <p class="text-center">Or go to <a class="forget">procplayer.tv/device</a> <br> and enter this code:</p>
              <div class="qr-code-number text-center">{{ userCode }}</div>
              <div v-if="qrError" class="text-center text-danger mt-2">{{ qrError }}</div>
              <div v-if="authCompleting" class="text-center my-3">
                <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                <div class="mt-2">Signing you in…</div>
              </div>
              <a v-else role="button" class="forget fw-bold text-center d-block mt-3" @click="switchToManual">
                ← Sign in with username and password
              </a>
            </div>
            <div v-else>
              <!-- Logo(s) - centering hardened -->
              <div class="text-center">
                <img src="../assets/images/logo.svg" alt="img" class="img-fluid d-none d-md-block mx-auto" style="display: block;" @click="this.$router.push('/')"/>
                <img src="../assets/images/logo-2.svg" alt="img" class="img-fluid d-block d-md-none mx-auto mobileSignLogo" style="display: block;" @click="this.$router.push('/')"/>
              </div>
              <form class="mt-3" @submit.prevent="doSignIn">
                <div class="input-group mb-3 border-bottom align-items-center">
                  <img src="../assets/images/user.svg" alt="icon" height="20" class="mx-2" />
                  <input type="text" class="form-control py-3" placeholder="Username" v-model="email" />
                </div>
                <div class="input-group border-bottom align-items-center">
                  <img src="../assets/images/lock.svg" alt="icon" height="20" class="mx-2" />
                  <input type="password" class="form-control py-3" placeholder="Password" v-model="password" />
                </div>
                <div v-if="error.length" class="alert-danger mt-3 pe-3 text-danger">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-exclamation-circle me-1 mb-1" viewBox="0 0 16 16">
                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                    <path d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995z" />
                  </svg>
                  {{ error }}
                </div>
                <div class="mt-2 mb-5 text-end">
                  <a role="button" class="forget" data-toggle="modal" @click="showModal = true">Forgot Password?</a>
                </div>
                <div class="btn-main">
                  <button ref="signInButton" class="btn w-100 border-0 rounded-0 py-3 text-white fw-signin fs-3 shine" :class="{ disabled: isButtonDisabled }">
                    <span v-if="!loading">Sign In</span>
                    <div v-else class="spinner-container py-3 align-items-baseline">
                      <span class="spinner-grow spinner-grow-sm" style="width: 0.8rem; height: 0.8rem;" role="status" aria-hidden="true"></span>
                      <span class="spinner-grow spinner-grow-sm" style="width: 0.8rem; height: 0.8rem;" role="status" aria-hidden="true"></span>
                      <span class="spinner-grow spinner-grow-sm" style="width: 0.8rem; height: 0.8rem;" role="status" aria-hidden="true"></span>
                    </div>
                  </button>
                </div>
                <a role="button" class="forget fw-bold mb-3 d-block mt-4 text-end" @click="switchToQr"> Go to QR login → </a>
              </form>
            </div>
          </div>
          <!--/col(1)-->
        </div>
        <!--/row-->
      </div>
      <!--/container-fluid-->
    </section>
  </div>
  <!-- forget password modal  -->
  <div class="modal d-block" v-if="showModal">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content ">
        <div class="modal-header align-self-center no-border">
          <h4 class="modal-title fw-bold" id="exampleModalLongTitle">Forgot Password</h4>
          <button role="button" class="close close-modal" data-dismiss="modal" aria-label="Close" @click="showModal = false">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body py-0">
          <section class="forgetpassword-page">
            <form class="mt-3" @submit.prevent="doForgetPassword">
              <div class="row">
                <div class="col-sm-12 col-12">
                  <div class="register-form">
                    <div class="input-group mb-3 border-bottom align-items-center">
                      <img src="../assets/images/user.svg" alt="icon" height="20" class="mx-2">
                      <input v-model="modalEmail" required="" type="email" name="modalEmail" autocomplete="off" class="form-control py-3" placeholder="Email">
                    </div>
                  </div>
                  <div v-if="modalError.length" class="alert-danger mt-3 pe-3 text-danger">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-exclamation-circle me-1 mb-1" viewBox="0 0 16 16">
                      <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                      <path d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995z" />
                    </svg>
                    {{ modalError }}
                  </div>
                </div>
              </div>
            </form>
          </section>
        </div>
        <div class="modal-footer align-self-center align-items-center no-border pt-0 ">
                  <div class="pop-btn">
                    <button role="button" data-toggle="modal" data-dismiss="modal" data-target="#exampleModal" class="btn w-100 border-0 rounded-0 py-2 px-5 text-white fw-bold fs-5 shine" :class="{ 'disabled': isButtonDisabled }" @click="doForgetPassword">
                      <span v-show="!modalloading">Submit</span>
                      <span v-show="modalloading" class="spinner-grow spinner-grow-sm" style="width: 0.8rem; height: 0.8rem;" role="status" aria-hidden="true"></span>
                      <span v-show="modalloading" class="spinner-grow spinner-grow-sm" style="width: 0.8rem; height: 0.8rem;" role="status" aria-hidden="true"></span>
                      <span v-show="modalloading" class="spinner-grow spinner-grow-sm" style="width: 0.8rem; height: 0.8rem;" role="status" aria-hidden="true"></span>
                    </button>
                  </div>
                </div>
      </div>
    </div>
  </div>
  <!-- popup modal  -->
  <div class="modal d-block" v-if="forgetPassword" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="card border border-0 w-100">
          <div class="row mx-0">
            <!-- LOGO  -->
            <div class="col-1 bg-success"></div>
            <div class="col-2 d-flex justify-content-center align-self-center px-1">
              <img src="../assets/green-tick.png" alt="Green tick" />
            </div>
            <!-- message  -->
            <div class="col-9 ps-2 vl">
              <p class="mb-0 mt-2 fw-bold">Success</p>
              <p class="mb-2 text-secondary">We’ve sent instructions on how to change your password to the following email address: <b>{{resetEmail}}</b>. Please do check your spam folder. </p>
            </div>
            <!-- close button  -->
            <div class="col-1 align-self-center text-center px-0">
              <!-- <a role="button" data-dismiss="modal" class="close">Close</a> -->
              <button role="button" class="close close-modal" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true" @click="forgetPassword=false">&times;</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- <Footer></Footer> -->
</template>

<script>
import {defineComponent} from 'vue'
import AuthService from '@/services/auth-service'
import UsersService from '@/services/users-service'
import LeagueService from '@/services/league-service'
import { event } from 'vue-gtag'
import {PasswordResetRequest} from "@/model/models";
import DeviceAuthService from "@/services/device-auth-service";
import { EncodeHintType } from "@zxing/library";
import {BrowserQRCodeSvgWriter} from "@zxing/browser";

export default defineComponent({
  components: {
  },
  setup() {
    const login = () => {
      event('login', { method: 'Google' })
    }
    return {
      login
    }
  },
  data() {
    return {
      email: '',
      modalEmail: '',
      resetEmail: '',
      password: '',
      error: '',
      modalError: '',
      forgetPassword: false,
      showModal: false,
      showReadMore: false,
      loading: false,
      modalloading: false,
      isButtonDisabled: false,
      showQR: false,
      authCompleting: false,
      // QR login state
      qrLoading: false,
      qrError: "",
      deviceCode: "",
      userCode: "",
      verificationUriComplete: "",
      expiresAtMs: 0,
      pollTimer: null,
    }
  },
  methods: {
    onEnter() {
      this.doSignIn();
    },
    doForgetPassword() {
      if (this.modalloading) return;
      this.modalloading = true;

      if (this.modalEmail == null || this.modalEmail === '') {
        this.modalError = "Please enter email address.";
        this.modalloading = false;
      } else {
        AuthService.initPasswordReset(new PasswordResetRequest(this.modalEmail)).then(()=> {
          localStorage.setItem('forgetPassword', "true")
          localStorage.setItem('resetEmail', this.modalEmail);
          window.location.reload();
        }).catch(() => {
          this.modalError = 'Email does not exist. Please try again with a valid email.';
          this.modalloading = false;
        })
      }
    },
    closeForgetPassword() {
      this.forgetPassword = false
    },
    doSignIn() {
      if (this.loading) return;
      this.loading = true;
      this.isButtonDisabled = true;
      AuthService.signIn(this.email, this.password).then(() => {
        this.doLoadPlans()
      }).catch(() => {
       this.error = 'Login failed';
       this.loading = false;
       this.isButtonDisabled = false;
      })
    },
    doLoadPlans() {
      UsersService.getUserStaticData().then(() => {
        UsersService.getUserProfile().then(() => {
          const userProfile = JSON.parse(localStorage.getItem('userProfile'))
          const userPlan = JSON.parse(localStorage.getItem('userPlan'))
          if (userProfile.planId != null && userProfile.planId !== '' && !userPlan.trial
              && userProfile.planActive && userProfile.planStatus && userProfile.planEndDate >= Date.now()) {
            LeagueService.getLeagueList().then(() => {
              const redirect = this.$route.query.redirect;
              console.log(redirect)
              if (typeof redirect === "string" && redirect.length > 0) {
                this.$router.replace(redirect);
              } else {
                this.$router.push({ path: "/events" });
              }
            })
          } else {
            // logout
            localStorage.clear()
            // show modal
            this.error = 'We apologize, but access to the ProcPlayer app is exclusive to valid paid profiles. Please consider upgrading to enjoy the full version of our service.';
            this.loading = false;
            this.isButtonDisabled = false;
          }
        }).catch(() => {
          this.error = 'Login failed';
          this.loading = false;
        })
      }).catch(() => {
        this.error = 'Login failed';
        this.loading = false;
      })
    },
    switchToManual() {
      this.stopPolling();
      this.authCompleting = false;
      this.showQR = false;
    },
    switchToQr() {
      this.showQR = true;
      this.$nextTick(() => {
        // Always re-render when returning (DOM exists now)
        if (this.verificationUriComplete) {
          this.renderQr(this.verificationUriComplete);
        }
        const expired = !this.expiresAtMs || Date.now() > this.expiresAtMs;
        if (!this.deviceCode || expired) {
          this.initDeviceLogin();
        } else {
          if (!this.pollTimer) this.startPolling();
        }
      });
    },
    async initDeviceLogin() {
      this.stopPolling();
      this.qrLoading = true;
      this.qrError = "";
      try {
        const res = await DeviceAuthService.init();
        this.deviceCode = res.deviceCode;
        this.userCode = res.userCode;
        this.verificationUriComplete = `${res.verificationUri}?user_code=${encodeURIComponent(res.userCode)}`;
        this.expiresAtMs = Date.now() + (res.expiresIn * 1000);
        // render QR
        this.renderQr(this.verificationUriComplete);
        // start polling
        this.startPolling();
      } catch (e) {
        console.log(e)
        this.qrError = "Failed to start QR login. Please try again.";
      } finally {
        this.qrLoading = false;
      }
    },
    renderQr(text) {
      if (!text) return;
      const el = document.getElementById("qrBox");
      if (!el) return;
      el.innerHTML = "";
      const size = Math.floor(el.clientWidth);
      const hints = new Map();
      hints.set(EncodeHintType.MARGIN, 1);
      const writer = new BrowserQRCodeSvgWriter();
      el.appendChild(writer.write(text, size, size, hints));
    },
    startPolling() {
      this.pollTimer = window.setInterval(() => this.pollOnce(), 5000);
    },
    stopPolling() {
      if (this.pollTimer) {
        clearInterval(this.pollTimer);
        this.pollTimer = null;
      }
    },
    async pollOnce() {
      if (!this.showQR) return;
      if (this.expiresAtMs && Date.now() > this.expiresAtMs) {
        this.stopPolling();
        this.qrError = "QR session expired. Please refresh.";
        return;
      }
      try {
        const res = await DeviceAuthService.poll(this.deviceCode);
        switch (res.status) {
          case "AUTHORIZATION_PENDING":
            return;
          case "EXPIRED":
            this.stopPolling();
            this.qrError = "QR session expired. Please refresh.";
            return;
          case "ISSUED":
            // already consumed by another poll
            this.stopPolling();
            return;
          case "AUTHORIZED":
            this.stopPolling();
            this.authCompleting = true;
            this.qrError = "";
            localStorage.setItem("access_token", res.accessToken);
            localStorage.setItem("refresh_token", res.refreshToken);
            this.doLoadPlans()
            return;
        }
      } catch (e) {
        // ignore transient errors
      }
    },
  },
  beforeMount() {
    if (localStorage.getItem('planExpired')) {
      this.error = 'We apologize, but access to the ProcPlayer app is exclusive to valid paid profiles. Please consider upgrading to enjoy the full version of our service.'
      localStorage.removeItem("planExpired")
    }
    if (localStorage.getItem('access_token')) {
      this.doLoadPlans()
    }
    if (localStorage.getItem('email')) {
      this.email = localStorage.getItem('email');
    }
    if (localStorage.getItem('sessionExpired')) {
      this.error = "Session expired. Log in again."
      localStorage.removeItem("sessionExpired")
    }
    if (localStorage.getItem('forgetPassword')) {
      this.forgetPassword=true
      this.resetEmail = localStorage.getItem('resetEmail')
      localStorage.removeItem("forgetPassword")
      localStorage.removeItem("resetEmail")
    }
    
    setTimeout(() => {
      this.forgetPassword = false;
    }, 7000);
  },
  beforeUnmount() {
    this.stopPolling();
  },
  beforeRouteLeave(to, from, next) {
    this.stopPolling();
    next();
  }
})

</script>

<style>
@import '../assets/style.css';
</style>
